import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { WebcamImage } from 'ngx-webcam';
import { Observable, Subject } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
  selector: 'app-webcam-dialog',
  templateUrl: './webcam-dialog.component.html',
  styleUrls: ['./webcam-dialog.component.scss']
})
export class WebcamDialogComponent implements OnInit {

  private frontCamera: boolean = true;
  takeSnapshot: Subject<void> = new Subject<any>();
  switchCamera: Subject<boolean> = new Subject<boolean>();
  isMobile: Observable<boolean>;
  cameraHeight: number = 500;
  cameraWidth: number = 500;
  imageType = 'image/jpeg';
  showControls: boolean = false;

  constructor(
    private dialogRef: MatDialogRef<WebcamDialogComponent>,
    private breakpoints: BreakpointObserver,
    private snackbar: MatSnackBar
  ) {
    /*this.isMobile$ = */this.breakpoints
      .observe([Breakpoints.HandsetPortrait])
      .pipe(map(result => result.matches))
      .subscribe(
        result => {

          if (result) {
            this.cameraHeight = window.screen.width;
            this.cameraWidth = window.screen.width;
          }

        }
      );
  }

  ngOnInit(): void {
    this.toggleControls();
  }

  doImageCapture() {
    this.takeSnapshot.next();
  }

  doSwitchCamera() {

    this.toggleControls();
    this.frontCamera = !this.frontCamera;
    this.switchCamera.next(this.frontCamera);

  }

  onCameraError(args) {

    this.snackbar.open('Erro ao abrir camera', 'OK', { duration: 5000 });
    alert(JSON.stringify(args));
    this.dialogRef.close();

  }

  onImageCapture(args: WebcamImage) {

    const { imageAsBase64, imageAsDataUrl } = args;

    const byteCharacters = atob(imageAsBase64);
    const byteArrays = [];
    const sliceSize = 512

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);

      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);

    }

    const imageBytes = new Blob(byteArrays, { type: this.imageType });
    this.dialogRef.close({ imageBytes, imageAsDataUrl });

  }

  private toggleControls() {
    this.showControls = false;
    setTimeout(() => this.showControls = true, 2000);
  }

}
